import { 
    Box, 
    Card, 
    CardContent,
    CardHeader, 
    Typography, 
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    AvatarGroup,
    Avatar,
    Tooltip,
    Stack,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    IconButton,
    Collapse,
    Divider,
    CircularProgress,
    Popper,
    Fade,
    Paper,
    CardActionArea,
} from '@mui/material';

import { styled } from '@mui/material/styles';

import {
    green,
    yellow,
    red,
    blue,
    grey
} from '@mui/material/colors';

import {
    Launch,
    ExpandMoreRounded,
    AttachmentRounded,
    MeetingRoomRounded,
    TimelineRounded,
    CloseRounded,
    DownloadingRounded
} from '@mui/icons-material';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent, {
    timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import format from 'date-fns/format';
import Recorder from 'components/Recorder';
import { third_party_constants } from 'constants/third_party_constants';

const MeetingsCard = ({ event }) => {
    const { title, start, end, source, profilePicturePath, link, attendees, extra, attachments } = event;

    const startTime = start && format(new Date(start), "h:mm a");
    const endTime = end && format(new Date(end), "h:mm a");
    const monthDayYear = start && format(new Date(start), 'MM/dd/yyyy');
    const token = useSelector((state) => state.auth.token);
    const currentWorkspaces = useSelector((state) => state.auth.user?.currentWorkspaces);

    // accepted, declined, needsAction, tentative, 
    const attendeeStatusColor = {
        "accepted": green,
        "declined": red,
        "needsAction": grey,
        "tentative": yellow,
    };

    const [openDialog, setOpenDialog] = useState(false);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [uploadLocation, setUploadLocation] = useState(null);

    const handleOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleErrorClose = () => {
        setOpenErrorDialog(false);
    }

    const handleLocationChange = (event) => {
        event.preventDefault();

        setUploadLocation(event.target.value);
    };

    {/* TODO: NEED TO FIX THIS FUNCTIONALITY */}
    const handleTranscriptUpload = async () => {
        switch (uploadLocation) {
            case "drive":
                let dataArr = [];
                for (const workspaceId of currentWorkspaces) {
                    const url = new URL(`${process.env.REACT_APP_PORT}/notes/createGoogleDoc/${workspaceId}`);

                    try {
                        const response = await fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`
                            },
                            body: JSON.stringify({ data: transcript, title: title })
                        });

                        const data = await response.json();
                        if (data) dataArr.push(data);
                    } catch (error) {
                        console.log(error.message);
                    }
                }

                return dataArr;
                break;
            case "onedrive":
                console.log("uploading this file to one drive");
                break;
            case "local":
                console.log("uploading this file to local");
                break;
            default:
                break;
        };
    };

    // const ErrorDialog = () => {
	// 	return (
	// 		<Dialog open={openErrorDialog} onClose={handleErrorClose}>
	// 			<DialogTitle>
	// 				<Box
	// 					display="flex"
	// 					justifyContent="space-between"
	// 					alignItems="center"
	// 				>
	// 					<Box>
	// 						<Typography variant="h4" fontWeight="bold">
	// 							Cannot add notes for all workspaces
	// 						</Typography>
	// 					</Box>
	// 				</Box>
	// 			</DialogTitle>

	// 			<DialogContent dividers>
	// 				<Typography variant="body1">
	// 					Please select a specific workspace before uploading any notes to a drive.
	// 				</Typography>
	// 			</DialogContent>
	// 		</Dialog>
	// 	);
	// };

    const ReviewDialog = ({ isTranscribing }) => {
        const token = useSelector((state) => state.auth.token);
        const allWorkspaces = useSelector((state) => state.auth.user?.allWorkspaces);

        const [displayDetails, setDisplayDetails] = useState(true);
        const [displayTranscription, setDisplayTranscription] = useState(true);
        const [loadingEllipsis, setLoadingEllipsis] = useState('');
        const [size, setSize] = useState(10);
        const [attachmentSummary, setAttachmentSummary] = useState('');
        const [actionItems, setActionItems] = useState({});
        const [isLoading, setIsLoading] = useState(false);
        const [anchorEl, setAnchorEl] = useState(null);
        const [popperOpen, setPopperOpen] = useState(() => {
            let popperObj = {};

            attendees?.forEach((attendee) => popperObj[attendee.email] = false);
            return popperObj;
        });
        const [interactions, setInteractions] = useState([]);
        const [isLoadingPerson, setIsLoadingPerson] = useState(false);
        const [isLoadingActionItems, setIsLoadingActionItems] = useState(false);

        const handlePersonClick = async (event, person) => {
            setInteractions([]);
            setAnchorEl(event.currentTarget);

            let open = popperOpen[person];
            let popperObj = popperOpen;
            popperObj[person] = !open;

            setPopperOpen(popperObj);

            {/* GRAB INTERACTIONS WITH THIS USER */}
            try {
                setIsLoadingPerson(true);
                const response = await fetch(`${process.env.REACT_APP_PORT}/people/getUserInteractions/${person}`, {
                    method: 'GET',  
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });
    
                const data = await response.json();
                setInteractions(data.interactions);
                setIsLoadingPerson(false);
            } catch (error) {
                setInteractions([]);
                setIsLoadingPerson(false);
            }
        };


        const handleSizeChange = (event) => {
            setSize(event.target.value);
        };

        const getMutualActionItems = async () => {
            try {
                setIsLoadingActionItems(true);
                let actionItemsObj = {};
                for (const attendee of attendees) {
                    const email = attendee?.email;
                    if (!Object.values(allWorkspaces)?.some((workspace) => workspace?.email === email)) {
                        const url = new URL(`${process.env.REACT_APP_PORT}/actionItems/getMutualActionItems/${email}`);
                        const response = await fetch(url, {
                            method: 'GET',
                            headers: { Authorization: `Bearer ${token}` }
                        });
        
                        const data = await response.json();
                        if (response.status === 200) {
                            const { actionItems, missedActionItems } = data; 
                            actionItemsObj[email] = actionItems;
                        }
                    }
                }

                console.log("set action items", isLoadingActionItems);
                setActionItems(actionItemsObj);
                setIsLoadingActionItems(false);
            } catch (error) {
                console.log("error is", error);
                setActionItems({});
                setIsLoadingActionItems(false);
            }
        };

        const getAttachmentSummary = async () => {
            if (attachments) {
                try {
                    setIsLoading(true);
                    // get attachment summary
                    const response = await fetch(`${process.env.REACT_APP_PORT}/summarizer/getAttachmentSummary/${size}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({ attachments })
                    });

                    const data = await response.json();
                    if (response.status === 200 && data.summary)
                        setAttachmentSummary(data.summary);
                    
                    setIsLoading(false);
                } catch (error) {
                    setIsLoading(false);
                    setAttachmentSummary(`Unable to get attachment summary: '${error.message}.'`);
                }
            }
        };

        useEffect(() => {
            const intervalId = setInterval(() => {
                setLoadingEllipsis((prevEllipsis) => prevEllipsis === '...' ? '' : prevEllipsis + '.');
            }, 300);

            return () => {
                clearInterval(intervalId);
            };
        }, []);

        const ExpandMore = styled((props) => {
            const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ theme, expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
        }));

        return (
            <Dialog open={openDialog} onClose={handleClose} fullWidth >
                <DialogTitle>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                        {title && <Typography variant="h4" fontWeight="bold">{title}</Typography>}
                        {!title && <Typography variant="h4" fontWeight="bold">Untitled Meeting</Typography>}
                        {start && end && <Typography variant="h6">{`${startTime} - ${endTime}`}</Typography>}
                    </Box>
                    {/* {source.icon && source.icon({ fontSize:"large" })} */}

                    <FormControl variant="standard" sx={{ minWidth: "120px" }}>
                        <InputLabel>Location</InputLabel>
                        <Select
                            value={uploadLocation}
                            label="Location"
                            onChange={handleLocationChange}
                        >
                            <MenuItem value={"drive"}>Google Drive</MenuItem>
                            <MenuItem value={"onedrive"}>OneDrive</MenuItem>
                            <MenuItem value={"local"}>Local Drive</MenuItem>
                        </Select>
                    </FormControl>
                    <Button onClick={handleTranscriptUpload}>Upload To Drive</Button>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Box>
                        <Box 
                            display="flex" 
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ px: "0.5rem", pb: "0.5rem" }}
                        >
                            <Typography 
                                variant="h5" 
                                fontWeight="bold"
                            >
                                Meeting Details
                            </Typography>

                            <ExpandMore
                                expand={displayDetails}
                                onClick={() => setDisplayDetails(!displayDetails)}
                                aria-expanded={displayDetails}
                                aria-label="Show Attendees"
                            >
                                <ExpandMoreRounded />
                            </ExpandMore>
                        </Box>
                        <Collapse
                            in={displayDetails}
                            timeout='auto'
                            unmountOnExit
                        >
                            <Card>
                                <CardContent>
                                    <Box justifyContent="center" sx={{ pb: "1rem" }}>
                                        <Typography variant="h6" fontWeight="bold">Attendees</Typography>
                                        <Box
                                            display="flex"
                                            sx={{ alignItems: "center", justifyContent: "space-evenly" }}
                                        >
                                            {attendees?.map((attendee) => {
                                                return (
                                                    <Box>
                                                        <Tooltip 
                                                            title={attendee?.email !== extra?.creator?.email ? 
                                                                `Email: ${attendee?.email}, Status: ${attendee?.responseStatus}` :
                                                                `Organizer: ${attendee?.email}, Status: ${attendee?.responseStatus}`
                                                            }
                                                            onClick={(e) => handlePersonClick(e, attendee?.email)}   // TODO: handle popup showing attendee info --> LOOK AT PEOPLE PAGE FOR THIS
                                                        >
                                                            <Avatar sx={{ mx: "0.5rem", bgcolor: attendeeStatusColor[attendee?.responseStatus][700] }} />
                                                        </Tooltip>
                                                        <Popper
                                                            open={popperOpen[attendee?.email]}
                                                            anchorEl={anchorEl}
                                                            placement='bottom'
                                                            sx={{
                                                                zIndex: 1500
                                                            }}
                                                            transition
                                                        >
                                                            {({ TransitionProps }) => (
                                                                <Fade {...TransitionProps} timeout={350}>
                                                                    <Card
                                                                        sx={{
                                                                            width: "400px",
                                                                            height: "400px",
                                                                            overflowY: "auto",
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            textAlign: "center",
                                                                            padding: "1rem",
                                                                            my: "1rem",
                                                                            borderRadius: "15px"
                                                                        }}
                                                                        raised
                                                                    >
                                                                        <CardContent>
                                                                            {isLoadingPerson && (
                                                                                <Box
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                >
                                                                                    <CircularProgress />
                                                                                </Box>
                                                                            )}
                                                                            {!isLoadingPerson && interactions?.length === 0 && (
                                                                                <Typography 
                                                                                    variant="body1" 
                                                                                    color="#3B57B8" 
                                                                                    display="flex"
                                                                                    sx={{
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                >
                                                                                    No previous interactions with this user!
                                                                                </Typography>
                                                                            )}
                                                                            {!isLoadingPerson && interactions?.length > 0 && (
                                                                                <Box mt="1rem" display="flex" flexDirection="column">
                                                                                    <Typography variant="h4" fontWeight="600" >
                                                                                        Your Interactions with {attendee?.email}
                                                                                    </Typography>
                                                                                    <Box
                                                                                        sx={{
                                                                                            borderColor: "#3B57B8",
                                                                                            borderRadius: "15px"
                                                                                        }}
                                                                                    >
                                                                                        <Timeline
                                                                                            sx={{
                                                                                                [`& .${timelineOppositeContentClasses.root}`]: {
                                                                                                    flex: 0.2,
                                                                                                },
                                                                                            }}
                                                                                        >   
                                                                                            {   interactions?.map((interaction, i) => (
                                                                                                    <TimelineItem key={interaction.id} >
                                                                                                        <TimelineOppositeContent color="text.secondary">
                                                                                                            {format(new Date(interaction.date), 'MMM dd, yyyy')}
                                                                                                        </TimelineOppositeContent>
                                                                
                                                                                                        <TimelineSeparator>
                                                                                                            <TimelineDot color='background'>
                                                                                                                {
                                                                                                                    interaction.type.startsWith('gmail') ? third_party_constants.gmail.icon()
                                                                                                                    : interaction.type === 'gcal' ? third_party_constants.google_calendar.icon()
                                                                                                                    : interaction.type === 'slack' ? third_party_constants.slack.icon()
                                                                                                                    : undefined
                                                                                                                }
                                                                                                            </TimelineDot>
                                                                                                            { i !== interactions.length - 1 && <TimelineConnector sx={{ bgcolor: 'primary.main' }} />}
                                                                                                        </TimelineSeparator >
                                                                
                                                                                                        <TimelineContent>
                                                                                                            <Typography variant="body">
                                                                                                                
                                                                                                            </Typography>
                                                                                                            <Card>
                                                                                                                <CardActionArea disableTouchRipple href={interaction.htmlLink} target="_blank">
                                                                                                                    <CardContent>
                                                                                                                        <Typography gutterBottom variant="h5" component="div">
                                                                                                                            {interaction.title}
                                                                                                                        </Typography>
                                                                                                                    </CardContent>
                                                                                                                </CardActionArea>
                                                                                                            </Card>
                                                                                                        </TimelineContent>
                                                                                                    </TimelineItem>
                                                                                                ))
                                                                                            }
                                                                                        </Timeline>
                                                                                    </Box>
                                                                                </Box>
                                                                            )}
                                                                        </CardContent>
                                                                    </Card>
                                                                </Fade>
                                                            )}
                                                        </Popper>
                                                    </Box>
                                                )  
                                            })}
                                        </Box>
                                    </Box>

                                    <Divider />
                                    <Box justifyContent="center" sx={{ py: "1rem" }}>
                                        <Typography variant="h6" fontWeight="bold">Meeting Type</Typography>
                                        <Box 
                                            display="flex"
                                            sx={{ alignItems: "center", justifyContent: "space-evenly"}}
                                        >
                                            {source.name}
                                            {source.icon && source.icon({ fontSize:"large" })}
                                            {!source.icon && <MeetingRoomRounded fontSize="large" />}
                                        </Box>
                                    </Box>

                                    {attachments && (
                                        <>
                                            <Divider />
                                            <Box justifyContent="center" sx={{ py: "1rem" }}>
                                                <Typography variant="h6" fontWeight="bold">Attachments</Typography>
                                                <Box
                                                    display="flex"
                                                    sx={{ 
                                                        alignItems: "center", 
                                                        overflow: "auto",
                                                        maxWidth: "100%",
                                                    }}
                                                >
                                                    {attachments?.map((attachment) => {
                                                        return (
                                                            <Box
                                                                display="flex"
                                                                flexDirection="column"
                                                                alignItems="center"
                                                                justifyContent="center"
                                                            >
                                                                <Tooltip
                                                                    title={attachment.title}
                                                                >
                                                                    <Button 
                                                                        href={attachment.fileUrl} 
                                                                        target="_blank" 
                                                                        variant="contained" 
                                                                        color={source?.color} 
                                                                        endIcon={<AttachmentRounded />} 
                                                                        sx={{
                                                                            textOverflow: 'ellipsis',
                                                                            overflow: 'hidden',
                                                                            whiteSpace: 'nowrap',
                                                                            mt: '0.5rem',
                                                                            mx: '0.5rem',
                                                                            maxWidth: '300px',
                                                                            display: 'block',
                                                                        }}
                                                                    >
                                                                        <Typography variant="body1" fontWeight="bold" noWrap>
                                                                            {attachment.title}
                                                                        </Typography>
                                                                    </Button>
                                                                </Tooltip>
                                                            </Box>
                                                        )
                                                    })}
                                                </Box>
                                            </Box>

                                            <Divider />
                                            <Box justifyContent="center" sx={{ py: "1rem" }}>
                                                <Box
                                                    display="flex"
                                                    sx={{
                                                        alignItems: "center",
                                                        justifyContent: "space-between"
                                                }}>
                                                    <Typography variant="h6" fontWeight="bold">What to Know</Typography>
                                                    <Box>
                                                        <FormControl>
                                                            <InputLabel id="select-summary-size">Size</InputLabel>
                                                            <Select
                                                                labelId="select-summary-size"
                                                                id="select-summary-size"
                                                                value={size}
                                                                label="Size"
                                                                onChange={handleSizeChange}
                                                            >
                                                                <MenuItem value={10}>10%</MenuItem>
                                                                <MenuItem value={20}>20%</MenuItem>
                                                                <MenuItem value={30}>30%</MenuItem>
                                                                <MenuItem value={40}>40%</MenuItem>
                                                                <MenuItem value={50}>50%</MenuItem>
                                                                <MenuItem value={60}>60%</MenuItem>
                                                                <MenuItem value={70}>70%</MenuItem>
                                                                <MenuItem value={80}>80%</MenuItem>
                                                                <MenuItem value={90}>90%</MenuItem>
                                                                <MenuItem value={100}>100%</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                        <Tooltip title={`Get summary for ${attachments?.length} documents`}>
                                                            <IconButton onClick={getAttachmentSummary}>
                                                                <DownloadingRounded fontSize="large" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Box>
                                                </Box>
                                                <Box 
                                                    display="flex"
                                                    sx={{ alignItems: "center", mt: "0.5rem" }}
                                                >
                                                    {/* Add functionality to prompt user with what they need to know before the meeting starts */}
                                                    {/* This should come from a summary of the main points about a set of attachments */}
                                                    {!isLoading && attachmentSummary === '' && <Typography>Select a summary size and press the download icon to load your summary!</Typography>}
                                                    {isLoading && (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <CircularProgress />
                                                        </Box>
                                                    )}
                                                    {!isLoading && attachmentSummary !== '' && <Typography>{attachmentSummary}</Typography>}
                                                </Box>
                                            </Box>
                                        </>
                                    )}
                                    {attendees && (
                                        <>
                                            <Divider />
                                            <Box justifyContent="center" sx={{ py: "1rem", width: "100%", overflow: "auto" }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        mb: '1rem',
                                                    }}
                                                >
                                                    <Typography variant="h6" fontWeight="bold" sx={{ mb: "1rem" }}>Shared Action Items</Typography>
                                                    <Tooltip title={`Get shared action items for ${attendees?.length - 1} people`}>
                                                        <IconButton onClick={getMutualActionItems}>
                                                            <DownloadingRounded fontSize="large" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                                <Box
                                                    display="flex"
                                                    sx={{ justifyContent: "space-evenly" }}
                                                >
                                                    {/* Grab the shared action items between users */}
                                                    {attendees?.map((attendee) => {
                                                        if (!Object.values(allWorkspaces)?.some((workspace) => workspace?.email === attendee?.email)) {
                                                            return (
                                                                <Card
                                                                    raised
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        width: "100%",
                                                                        noWrap: true,
                                                                        mx: "1rem",
                                                                        p: '15px'
                                                                    }}
                                                                >
                                                                    <Typography 
                                                                        variant="h6" 
                                                                        fontWeight="bold" 
                                                                        textOverflow="ellipsis"
                                                                        width="100%"
                                                                    >
                                                                        {attendee?.email}
                                                                    </Typography>
                                                                    <Divider sx={{ my: '1rem' }} />
                                                                    <Box>
                                                                        {isLoadingActionItems && (
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    justifyContent: 'center',
                                                                                    alignItems: 'center',
                                                                                }}
                                                                            >
                                                                                <CircularProgress />
                                                                            </Box>
                                                                        )}
                                                                        {!isLoadingActionItems && Object.values(actionItems)?.length === 0 && <Typography>Press the download icon to load your shared action items!</Typography>}
                                                                        {!isLoadingActionItems && Object.values(actionItems)?.length !== 0 && actionItems[attendee?.email]?.length > 0 && actionItems[attendee?.email]?.map((actionItem) => {
                                                                            return <Typography>{`${actionItem.title}: ${actionItem.item}`}</Typography>
                                                                        })}
                                                                        {!isLoadingActionItems && actionItems[attendee?.email]?.length === 0 && (
                                                                            <Typography>No action items shared with this attendee</Typography>
                                                                        )}
                                                                    </Box>
                                                                </Card>
                                                            )
                                                        }
                                                    })}
                                                </Box>
                                            </Box>
                                        </>
                                    )}
                                </CardContent>
                            </Card>
                        </Collapse>
                    </Box>

                    <Box 
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ px: "0.5rem", pt: "1rem", pb: "0.5rem" }}
                    >
                        <Typography 
                            variant="h5" 
                            fontWeight="bold"
                        >
                            Transcription
                        </Typography>  
                        <ExpandMore
                                expand={displayTranscription}
                                onClick={() => setDisplayTranscription(!displayTranscription)}
                                aria-expanded={displayTranscription}
                                aria-label="Show Attendees"
                            >
                                <ExpandMoreRounded />
                        </ExpandMore>
                    </Box>
                    <Collapse
                        in={displayTranscription}
                        timeout='auto'
                        unmountOnExit
                    >
                        <Card>
                            <CardContent>
                                {isTranscribing && (
                                    <Typography>
                                        Transcription in progress{loadingEllipsis}
                                    </Typography>
                                )}   
                                {!isTranscribing && transcript.length === 0 && (
                                    <Typography>No transcript available yet</Typography>
                                )}               
                                {!isTranscribing && transcript?.map((line, index) => {
                                    const [speaker, ...words] = line.split('\n');
                                    return (
                                        <Stack spacing={0} key={index}>
                                            <Typography variant="body" fontWeight="700">{speaker}</Typography>
                                            <Typography variant="body">{words.join(' ')}</Typography>
                                            <Typography variant="body">&nbsp;</Typography>
                                        </Stack>
                                    );
                                })}
                            </CardContent>
                        </Card>
                    </Collapse>
                </DialogContent>
            </Dialog>
        );
    };
    
    const [ transcript, setTranscript ] = useState([]);
    const [ isTranscribing, setIsTranscribing ] = useState(false);

    const handleTranscriptChange = (transcript) => {
        setIsTranscribing(true);
        const normalized = transcript.trim().split('\n\n');
        console.log(normalized)
        setTranscript(normalized);
        setIsTranscribing(false);
    };

    return (
        <Card raised sx={{ height: '300px', width: "250px", borderRadius: "10px", background: "linear-gradient(179.2deg, #3B57B8 -105.91%, #DCE1FF 63.24%)" }} >
            <CardContent component={Box} display="flex" flexDirection="column" gap="1rem">
                { /* Meeting Header (Name, Time, Source Icon) */}
                <Box display="flex" justifyContent="space-between">
                    <Box>
                        {title && <Typography variant="h4" fontWeight="bold">{title}</Typography>}
                        {!title && <Typography variant="h4" fontWeight="bold">Untitled Meeting</Typography>}
                        {start && end && monthDayYear && <Typography variant="h6">{monthDayYear}</Typography>}
                        {start && end && <Typography variant="h6">{`${startTime} - ${endTime}`}</Typography>}
                    </Box>

                    <Avatar src={profilePicturePath} sx={{ width: 34, height: 34, mr: "0.5rem" }} />
                    {source.icon && source.icon({ fontSize:"large" })}
                </Box>
                
                { /* Meeting Buttons (Join Meeting, Review) */}
                <Box width="100%" display="flex" flexDirection="column" gap="0.5rem">

                    { 
                        source.name === "In Person" ? (
                            // Physical Meeting, start recording
                            <Recorder onTranscriptChange={handleTranscriptChange} />
                        ) : (
                            // Virtual Meeting, join link
                            <Button href={link} target="_blank" variant="contained" color={source.color} sx={{ textTransform: "none" }}>
                                <Typography variant="secondary" >{`Join on ${source.name}`}</Typography>
                            </Button>
                        ) 
                    }

                    <Button variant="outlined" color={source?.color} onClick={handleOpen} endIcon={<TimelineRounded />} sx={{ textTransform: "none" }}>
                        <Typography variant="secondary" fontWeight="600" textAlign="center">Review</Typography>
                    </Button>

                    <ReviewDialog isTranscribing={isTranscribing} />
                </Box>

                { /* Meeting attendees */}
                {   attendees && 
                    <Box display="flex" flexDirection="column" alignItems="flex-start" gap="0.5rem">
                        <Typography variant="h5" fontWeight="700">Attendees: </Typography>
                        {console.log("attendees are", attendees)}
                        <AvatarGroup max={3}>
                            {   attendees?.filter( (attendee) => !attendee.self )  // skip self
                                ?.map( (attendee) => (
                                    <Tooltip key={attendee.email} title={attendee.email} arrow>
                                        <Avatar sx={{ bgcolor: attendeeStatusColor[attendee.responseStatus][700] }} />
                                    </Tooltip>
                            ))}
                        </AvatarGroup>
                    </Box>
                }
            </CardContent>
        </Card>
    );
};

export default MeetingsCard;